export const STORE_CODES = Object.freeze({
  sparkAU: "cpq_store_view",
  sparkNZ: "spark_nz_store_view",
  wsoAU: "wso_au_store_view",
  wsoNZ: "wso_nz_store_view"
});

export const ADJUSTMENT_PERIODS = [
  {value: "1_MONTH", label: "1 Month"},
  {value: "3_MONTHS", label: "3 Months"},
  {value: "6_MONTHS", label: "6 Months"}
];

export const PRODUCT_IMAGE_BASE_URL = `${process.env.REACT_APP_MAGENTO_BASE}/media/catalog/product/`;

export const CALCULATOR_API = `${process.env.REACT_APP_MAGENTO_BASE}/calculator/index/processquestionnaire/`;

// TODO: get UNIFLOW_CPQ_PRODUCT_TYPE & UNIFLOW_SOFTWARE_PATH from backend configuration
export const UNIFLOW_CPQ_PRODUCT_TYPE = "36";
export const UNIFLOW_SOFTWARE_PATH = "/category/197";

export const PERSISTENCE_KEY = "spark";

export const MAX_QUANTITY = 150;
export const HARDWARE_DISCOUNT = 0.75;
export const SOFTWARE_DISCOUNT = 0.75;
export const SAAS_DISCOUNT = 0.75;
export const CC_COLOR_DISCOUNT = 0.75;
export const CC_BW_DISCOUNT = 0.75;

export const OPPORTUNITY_TYPES_NO_DISCOUNT = []
export const OPPORTUNITY_TYPES_NZ = ["COMMERCIAL_NZ","AOG_FIXED_NZ","AOG_DISCOUNT_NZ","LARGE_CUSTOMERS_NZ"]
export const OPPORTUNITY_TYPES_NZ_GOVERNMENT = ["AOG_FIXED_NZ","AOG_DISCOUNT_NZ"]

export const IS_PROD = window.location.host.indexOf('spark.canon.co') >= 0

export function setIS_NZ(opportunity)
{
  IS_NZ = OPPORTUNITY_TYPES_NZ.includes(opportunity) 
}
export var IS_NZ = false;

export const CFNZ_FINANCE_SUBTYPE = ["RENTAL", "LEASE"];
export const CFNZ_FINANCE_TERM = {"min": 12, "max": 65, "default": 12};//12 to 60